import React from 'react';
import { Link } from 'react-router-dom';
import google from '../assets/google1.svg';
 
const LoginCompo = () => {
    return (
        <>
            <div className='container md:w-[60%] w-[90%] mt-10 mx-auto '>
                <div>
                    <div className='login-bg  rounded-xl mx-auto'>
                        <h1 className='text-center py-3 text-[56px] font-bold  text-white  ' >Login</h1>
                    </div>

                    <div className='     '>

                        <h2 className=' text-gray-400 text-sm float-right mt-3 '>Don't have an account? <span className='text-blue-400 font-semibold'>   <Link to="/SignUp">  Sign Up </Link> </span></h2>
                    </div>
                     
 
                    
                
                    <div className='w-[90%] my-10 md:w-[70%] mx-auto'>

                    <form>
  <div class="mb-3">
    <label for="email" class="block mb-2 text-[12px] font-medium text-[#131436]">Email address</label>
    <input type="email" id="email" class="shadow-sm h-[50px] bg-[#fbfeff] focus:bg-white border border-gray-300 text-gray-900 text-sm rounded-2xl   block w-full p-2.5  " placeholder="Enter email address" required/>
  </div>
  <div class="mb-3">
    <label for="password" class="block mb-2 text-[12px] font-medium text-[#131436]  ">Your password</label>
    <input type="password" id="password" class="shadow-sm h-[50px] bg-[#fbfeff] focus:bg-white border border-gray-300 text-gray-900 text-sm rounded-2xl  w-full p-2.5  " placeholder='Enter password' required/>
  </div>
   
   <center>
  <button type="submit" class="text-white my-6  bg-blue-400 hover:bg-blue-500    font-medium rounded-xl text-sm px-16 h-[50px] text-center  ">Login</button>
  </center>
</form>
                    </div>

                </div>
            </div>
        </>
    )
}

export default LoginCompo